import { Factory, Pencil } from 'lucide-react';
import { cn } from '../../../lib/utils';

export type AppliedFrom = {
	label: string;
	stillMatches: boolean;
	vetterEntity?: { id: string; name: string } | null;
};

/**
 * Under a tier's cost: which supplier's price it came from. The cost column is
 * narrow, so it names the supplier and keeps the backend's full sentence ("From
 * Patrick Vetter's price · Sep 30", or "Changed since … was used") for hover.
 * Nothing for a cost typed by hand.
 */
export function AppliedFromNote({ from }: { from?: AppliedFrom | null }) {
	if (!from) return null;
	const Icon = from.stillMatches ? Factory : Pencil;
	return (
		<span
			title={from.label}
			aria-label={from.label}
			className={cn(
				'inline-flex w-fit max-w-full items-center gap-0.5 text-2xs text-text-4',
				!from.stillMatches && 'italic'
			)}
		>
			<Icon size={10} className="shrink-0" />
			<span className="truncate">
				{from.stillMatches ? '' : 'edited · '}
				{from.vetterEntity?.name ?? 'Supplier'}
			</span>
		</span>
	);
}
